import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import history from '../../../../history';
import {GetReportsByTypeCategory} from '../../actions/index';

class AuditToolsReportsList extends Component {
  constructor(props) {
    super(props);
  };

  componentWillMount() {
    this.loadData();
  }

  loadData() {   
    this.props.GetReportsByTypeCategory('REPORTS_AUDIT_TOOLS_REPORTS');
  }

  handleViewReport = (event, navigationLink) => { 
    history.push(navigationLink);
  };
  renderReportData = () => {
    if (this.props.reportsbytypecategoryList && this.props.reportsbytypecategoryList.data && this.props.reportsbytypecategoryList.data.length >= 0) {
      return (
        this.props.reportsbytypecategoryList.data.map((Obj, index) => {      
          return(
            <div className="col-sm-4 col-md-3" key={index} onClick={(e) => this.handleViewReport(e, Obj.navigationLink)}>
                  <div className="report_box">
                    <div className="reportdate">
                        {/* <i className="fa fa-heart" aria-hidden="true"></i> */}
                    </div>
                      <div className="reportname">
                        {/* <h3>Appointment <span className="block">Report</span></h3> */}                   
                        <b className="fa fa-file-text-o" aria-hidden="true"></b>
                        {/* <button onClick={(e) => this.handleViewReport(e, Obj.navigationLink)} type="button" title="View Report" className="tbactionbtn bluefont"><b className="fa fa-file-text-o" aria-hidden="true"></b></button> */}
                        <h3>{Obj.actionName}</h3>
                      </div>
                  </div>
            </div>
              )
          }
        ));
    } else {
      return (<div className="col-sm-12 history_card mt20">
        <div className="familydl text-center no-record">
          No record found.
        </div>
      </div>);
    }
  }

  render() {   
    return (
      <div>
        <h2 className="page_title">Audit Tools</h2>
        <div className="clearfix"></div>
        <div className="readmin-panel">
            <div className="panel-body">
              <div className="row">
                  {this.renderReportData()}
              </div>
            </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    reportsbytypecategoryList: state.report.reportsbytypecategory,    
  };
};

AuditToolsReportsList = reduxForm({
  form: 'AuditToolsReportsListForm',
})(AuditToolsReportsList);

export default connect(mapStateToProps, { GetReportsByTypeCategory })(AuditToolsReportsList);



// WEBPACK FOOTER //
// ./src/modules/Reports/components/AuditToolsReports/index.js